import { render, staticRenderFns } from "./AccessPointsList.vue?vue&type=template&id=638446c4"
import script from "./AccessPointsList.vue?vue&type=script&lang=js"
export * from "./AccessPointsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports